export enum DiversificationMode {
  Default = 'default',
  Tiered = 'tiered',
}

export interface TieredDiversificationTier {
  id: string
  maxMarketValue: number | null // null for the final "catch-all" tier
  weightRange: [number, number] // [min, max] weight percentages
}

// Unified diversification constraint state types
interface SimpleDiversificationRange {
  mode: DiversificationMode.Default
  weightRange: [number, number] // [min, max] percentages
  id?: string // original API constraint ID for round-trip preservation
}

interface TieredDiversificationConfig {
  mode: DiversificationMode.Tiered
  tiers: TieredDiversificationTier[]
  id?: string // original API piecewise constraint ID for round-trip preservation
}

export type DiversificationConstraintValue =
  | SimpleDiversificationRange
  | TieredDiversificationConfig
